import clsx from "classnames"
// Import all thumbnail images
import thumbnailAi from "../../assets/thumbnail_ai.png"
import thumbnailBusiness from "../../assets/thumbnail_business.png"
import thumbnailDaily from "../../assets/thumbnail_daily.png"
import thumbnailDefault from "../../assets/thumbnail_default.png"
import thumbnailEnterprises from "../../assets/thumbnail_enterprises.png"
import thumbnailEnvironment from "../../assets/thumbnail_environment.png"
import thumbnailEnvironmentAlt from "../../assets/thumbnail_environment_alt.png"
import thumbnailEurope from "../../assets/thumbnail_europe.png"
import thumbnailGlobal from "../../assets/thumbnail_global.png"
import thumbnailHealth from "../../assets/thumbnail_health.png"
import thumbnailPolitics from "../../assets/thumbnail_politics.png"
import thumbnailScienceFr from "../../assets/thumbnail_science_fr.png"
import thumbnailSomethingGood from "../../assets/thumbnail_something_good.png"
import thumbnailSpotlight from "../../assets/thumbnail_spotlight.png"
import thumbnailUk from "../../assets/thumbnail_uk.png"
import thumbnailFr from "../../assets/thumbnail_fr.png"
import thumbnailWeekendFr from "../../assets/thumbnail_weekend_fr.png"
import thumbnailWeekenderFr from "../../assets/thumbnail_weekender_fr.png"
import thumbnailWorldAffairs from "../../assets/thumbnail_world_affairs.png"

interface ThumbnailProps {
  regionCode: string
  newsletterName: string
  className?: string
}

/**
 * Maps newsletter thumbnails based on region code and newsletter name.
 * Based on the structure from marcus-playground.
 * Returns null if no matching thumbnail is found.
 */
export const Thumbnail = ({ regionCode, newsletterName, className }: ThumbnailProps) => {
  const thumbnailUrl = getThumbnailUrl(regionCode, newsletterName)

  if (!thumbnailUrl) {
    return null
  }

  const isPlaceholder = thumbnailUrl === thumbnailDefault.src

  return (
    <div
      className={clsx(className, { "bg-gray-50": isPlaceholder })}
      style={{
        backgroundImage: `url(${thumbnailUrl})`,
      }}
    />
  )
}

/**
 * Gets the thumbnail URL based on region code and newsletter name.
 * Maps based on the structure from marcus-playground/app/lib/newsletters.ts
 */
function getThumbnailUrl(regionCode: string, newsletterName: string): string | null {
  // Normalize region code to match marcus-playground region IDs
  const normalizedRegion = regionCode.toLowerCase()

  // Create a mapping key from region and newsletter name
  const key = `${normalizedRegion}:${newsletterName.toLowerCase().trim()}`

  // Mapping based on marcus-playground structure
  const thumbnailMap: Record<string, string> = {
    // UK region
    "uk:the daily": thumbnailUk.src,
    "uk:politics weekly": thumbnailPolitics.src,
    "uk:imagine": thumbnailEnvironmentAlt.src,
    "uk:world affairs briefing, from the uk": thumbnailWorldAffairs.src,
    "uk:something good": thumbnailSomethingGood.src,
    "uk:story spotlight": thumbnailSpotlight.src,
    "uk:the weekender": thumbnailDaily.src,
    "uk:global": thumbnailGlobal.src,
    "uk:global economy & business": thumbnailBusiness.src,
    "uk:europe newsletter": thumbnailEurope.src,
    "uk:the conversation ai": thumbnailAi.src,

    // France region
    "fr:la newsletter quotidienne": thumbnailFr.src,
    "fr:la newsletter histoire": thumbnailDefault.src,
    "fr:le débrief": thumbnailWeekendFr.src,
    "fr:la newsletter sciences": thumbnailScienceFr.src,
    "fr:la newsletter environnement": thumbnailEnvironment.src,
    "fr:la newsletter santé": thumbnailHealth.src,
    "fr:la newsletter entreprise(s)": thumbnailEnterprises.src,
    "fr:europe newsletter": thumbnailEurope.src,
    "fr:la newsletter du week-end": thumbnailWeekenderFr.src,
  }

  return thumbnailMap[key] || null
}
